export default __webpack_public_path__ + "assets/a483c49d7c98d0287ba1d999cf7836cb.webp";